export default {
  dashboard: {
    greeting: "Hello",
    welcome: "Welcome to your dashboard.",
    counters: {
      addressed: "Addressed counters",
      eligible: "Eligible counters",
      eligiblePaid: "Eligible counters paid",
      eligibleInProgress: "Eligible counters in progress",
      eligibleRest: "Eligible counters remaining to pay",
      installed: "Installed counters",
      title: "Counters"
    },
    totalCollected: "Total amount collected",
    amountFor: "For an amount of: {amount} FCFA"
  }
}
